import { combineReducers } from 'redux';
import msgReducer from './msgReducer';
import baseInfoReducer from './baseInfoReducer';
import notificationReducer from './notificationReducer';

export default combineReducers({
  chatMsg: msgReducer,
  baseInfo: baseInfoReducer,
  notificationInfo: notificationReducer
})